
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

console.log('[Main] Starting app initialization');

// Ensure root element exists and is visible
const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

// Force root element visibility immediately
root.style.display = 'block';
root.style.visibility = 'visible';
root.style.opacity = '1';
root.style.height = '100%';
root.style.width = '100%';
root.style.backgroundColor = '#ffffff';

// Also ensure body and html are visible
document.documentElement.style.display = 'block';
document.documentElement.style.visibility = 'visible';
document.documentElement.style.opacity = '1';

document.body.style.display = 'block';
document.body.style.visibility = 'visible';
document.body.style.opacity = '1';
document.body.style.backgroundColor = '#ffffff';

// Create and render React app immediately
try {
  const reactRoot = ReactDOM.createRoot(root);
  
  reactRoot.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  console.log('[Main] React app rendered successfully');
  
  // Mark app as loaded
  setTimeout(() => {
    document.body.classList.add('app-loaded');
    
    // Hide any fallback loading UI
    const fallback = document.getElementById('testflight-fallback');
    if (fallback) {
      fallback.style.display = 'none';
    }
    
    console.log('[Main] App fully loaded');
  }, 100);
  
} catch (error) {
  console.error('[Main] Error rendering React app:', error);
  
  // Emergency fallback - show something instead of blank screen
  root.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#fff;text-align:center;font-family:system-ui;">
      <div>
        <h1 style="color:#333;margin-bottom:1rem;font-size:2rem;">LiveTrack</h1>
        <p style="color:#666;margin-bottom:1rem;">Application failed to load</p>
        <p style="color:#999;font-size:0.875rem;">Error: ${error instanceof Error ? error.message : 'Unknown error'}</p>
        <button onclick="window.location.reload()" style="margin-top:1rem;padding:0.75rem 1.5rem;background:#007AFF;color:white;border:none;border-radius:0.5rem;font-size:1rem;cursor:pointer;">
          Reload App
        </button>
      </div>
    </div>
  `;
}
